import moment from 'moment-timezone';
import uuid from 'uuid/v1';

import { WEEK_DAYS } from '../../constants/base';

moment.tz.setDefault('CET');

export const ACCOMMODATIONS_TAB = 0;

export const PRICES_PER_DAY = {
  USD: '0',
  EUR: '0',
  NOK: '0'
};

export const INITIAL_ACCOMMODATION_FORM_DATA = {
  generalForm: {
    productCode: '',
    coverPhoto: {},
    availability: {
      startDate: moment(),
      endDate: null
    },
    checkInAfter: moment(),
    checkOutBefore: moment(),
    bedDetails: [],
    minNights: 1,
    deactivatedDates: [{ id: uuid(10) }],
    color: ''
  },
  descriptionForm: {},
  pricesFixedForm: {
    USD: '0',
    EUR: '0',
    NOK: '0'
  },
  pricesCategoryForm: {
    categories: [
      {
        id: uuid(),
        participant: 'Adult',
        USD: '0',
        EUR: '0',
        NOK: '0'
      }
    ]
  },
  pricesDailyForm: {
    days: WEEK_DAYS.map(day => ({
      id: uuid(),
      day: day,
      ...PRICES_PER_DAY
    }))
  },
  futurePricesForm :{
   futureRatePlanIds: {},
  },
  addOnsForm: {
    addOns: []
  },
  mandatoryFeesForm: {
    mandatoryFees: []
  },
  relatedActivitiesForm: {
    relatedActivities: []
  },
  integrationForm: {
    integrations: []
  }
};

export const ACCOMMODATION_FORMS_NUMBERS = {
  generalForm: 0,
  descriptionForm: 1,
  pricesForm: 2,
  futurePricesForm: 3,
  addOnsForm: 4,
  mandatoryFeesForm: 5,
  relatedActivitiesForm: 6,
  integrationForm: 7,
  
};

export const ACCOMMODATION_FORMS_ORDER = [
  'generalForm',
  'descriptionForm',
  {
    0: 'pricesFixedForm',
    1: 'pricesCategoryForm',
    2: 'pricesDailyForm',
  },
  'futurePricesForm',
  'addOnsForm',
  'mandatoryFeesForm',
  'relatedActivitiesForm',
  'integrationForm'
];

export const ACCOMMODATION_PRICES_FORMS_NUMBERS = {
  pricesFixedForm: 0,
  pricesCategoryForm: 1,
  pricesDailyForm: 2,
};
